import { render, staticRenderFns } from "./RecipientsList.vue?vue&type=template&id=7b064177&scoped=true&"
import script from "./RecipientsList.vue?vue&type=script&lang=js&"
export * from "./RecipientsList.vue?vue&type=script&lang=js&"
import style0 from "./RecipientsList.vue?vue&type=style&index=0&id=7b064177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b064177",
  null
  
)

export default component.exports